import { render, staticRenderFns } from "./BatchList.vue?vue&type=template&id=9518d50a&scoped=true&"
import script from "./BatchList.vue?vue&type=script&lang=js&"
export * from "./BatchList.vue?vue&type=script&lang=js&"
import style0 from "./BatchList.vue?vue&type=style&index=0&id=9518d50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9518d50a",
  null
  
)

export default component.exports